import React from 'react';

/** Inline **markdown-style** bold segments for chat bubbles. */
function renderChatInlineFormatting(text: string): React.ReactNode {
  if (!text) return null;
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => {
    if (part.length > 4 && part.startsWith('**') && part.endsWith('**')) {
      return (
        <strong key={i} className="font-semibold text-gray-900">
          {part.slice(2, -2)}
        </strong>
      );
    }
    return <span key={i}>{part}</span>;
  });
}

interface ChatBotBubbleContentProps {
  text: string;
}

/** Bot replies: paragraphs + preserved line breaks + simple **bold**. */
export default function ChatBotBubbleContent({ text }: ChatBotBubbleContentProps) {
  const blocks = text.split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);
  if (blocks.length === 0) return null;
  if (blocks.length === 1) {
    return (
      <div className="text-sm leading-relaxed whitespace-pre-line">
        {renderChatInlineFormatting(blocks[0])}
      </div>
    );
  }
  return (
    <div className="text-sm leading-relaxed space-y-2">
      {blocks.map((block, i) => (
        <p key={i} className="m-0 whitespace-pre-line">
          {renderChatInlineFormatting(block)}
        </p>
      ))}
    </div>
  );
}
